export enum PromoCodeType {
	ABSOLUTE = 'absolute',
	RELATIVE = 'relative',
	DELIVERY_FEE = 'delivery_fee',
	BOGO = 'bogo',
	REWARD = 'reward',
	FREE_ARTICLE = 'free_article',
	CHEAPEST_FREE_ARTICLE = 'cheapest_free_article',
	DEPENDENCY_FREEE_ARTICLE = 'dependency_free_article',
	MULTIPLE_FREE_ARTICLES = 'multiple_free_articles',
	VOID = 'void',
}
